import * as $ from "jquery";
import * as Backbone from "backbone";
import * as _ from "underscore";
import * as Marionette from "backbone.marionette";
import { on, Options } from "../utils/decorators";

@Options({
    template: false,
    ui: {}
})
export default class BlogCategory extends Marionette.View<Backbone.Model>{

    constructor(options?:object, config?:object) {
        super(options);
    }

    onRender(){
        let placeholder = 'Categories';
        (<any>document.querySelector('.blog-category-select > option')).selected = true;


        (<any>$(document.querySelector('.blog-category-select'))).select2({
            dropdownAutoWidth: true,
            minimumResultsForSearch: Infinity, // removes search bar in results
            placeholder: placeholder,
            allowClear: true,
            width: '220px',
            theme: "blog-category-select"
        }).on('select2:select', function (ev) {
            console.log('change', ev.params.data.element.dataset.href);
            document.location.href = ev.params.data.element.dataset.href;
        });
    }
}



// WEBPACK FOOTER //
// ./@modules/views/blog-category.ts